import React, { useCallback, useState } from 'react'
import styled from 'styled-components'

import { Button } from '@nexiahome/ui-common/components/primitives/buttons'

import SelectCustomerDropdown from 'pages/UnassignedDevice/SelectCustomerDropdown'

import { CustomerBase } from 'types/Customer'
import { customerDisplayName } from 'helpers/formatters'

type Props = {
  selectedCustomer: CustomerBase | null
  customers: Array<CustomerBase>
  onSelectCustomerCallback: (customer: CustomerBase) => void
}

const SelectCustomer = ({ onSelectCustomerCallback, customers, selectedCustomer }: Props) => {
  const [showSelectCustomerDropdown, setShowSelectCustomerDropdown] = useState(false)

  const onSelectCustomer = useCallback((customer: CustomerBase) => {
    onSelectCustomerCallback(customer)
    setShowSelectCustomerDropdown(false)
  }, [onSelectCustomerCallback])

  return (
    <S.SelectCustomer>
      <Button
        decoration="positive"
        icon="arrow-down2"
        onPress={() => setShowSelectCustomerDropdown(!showSelectCustomerDropdown)}
        aria-label="select-customer"
        styles={{ button: { flexDirection: 'row-reverse', alignSelf: 'flex-start' }, iconContainer: { marginLeft: 15 } }}
        text={(selectedCustomer && customerDisplayName(selectedCustomer.firstName, selectedCustomer.lastName, selectedCustomer.companyName)) || 'SELECT CUSTOMER...'}
      />
      <S.SelectCustomerDropdown
        isDropdownOpen={showSelectCustomerDropdown}
        onCloseDropdown={() => setShowSelectCustomerDropdown(false)}
        customers={customers}
        onSelectCustomerCallback={onSelectCustomer}
      />
    </S.SelectCustomer>
  )
}

export default SelectCustomer

const S = {
  SelectCustomer: styled.div`
    display: flex;
  `,
  SelectCustomerDropdown: styled(SelectCustomerDropdown)`
    margin-top: 34px;
  `
}
